import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {HhgCarrierRateFilingService} from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {BehaviorSubject} from 'rxjs';
import {RatesSroMasterService} from '../../services/rates-sro-master/rates-sro-master.service';
import {takeWhile} from 'rxjs';
import {RateTypes, SROMaster} from '../hhg-carrier-rate-filing/hhgrates';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ControlType} from '../hhg-rate-duns/control-type';
import {User} from '../../services/user/user';
import {UserService} from '../../services/user/user.service';
import {CarrierService} from '../../services/carrier/carrier.service';
import AppConstants, {hhg_download_template_success} from '../../shared/common-components/AppConstants';
import {DownloadFileResponse} from '../../shared/common-components/file-storage/downloadFileResponse';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-hhg-template-download',
    templateUrl: './hhg-template-download.component.html',
    styleUrls: ['./hhg-template-download.component.css'],
    standalone: false
})
export class HhgTemplateDownloadComponent implements OnInit, OnDestroy {
  private observer$ = new BehaviorSubject(true);
  rateTypes: RateTypes[];
  sroTypeList: SROMaster[];
  sroList: SROMaster[];
  hhgTemplateForm: UntypedFormGroup;
  tmssloader: any;
  currentUser: User | any;
  carrierId: any;
  rateBidCyclesId: any;
  controlTypeVal: ControlType[];
  controlKey: ControlType;
  carrierEntity: any;
  isRsfp: boolean;
  rsfpCarrierList: any[];
  rsfpCarrierId: number;
  downloadCarrierId: any;
  message: any;

  constructor(private hhgService: HhgCarrierRateFilingService, private ratesSroMasterService: RatesSroMasterService,
              private alertService: AlertService, private loader: LoadingService, private fb: UntypedFormBuilder,
              private userService: UserService,
              private hhgrateService: HhgCarrierRateFilingService,
              private carrierService: CarrierService) {
    this.tmssloader = this.loader;

    this.carrierService.getRateBidCycleId()
      .pipe(takeWhile(() => this.observer$.value)).subscribe((res: any) => {
      this.rateBidCyclesId = res.ratesBidcyclesId; 
    });

  }

  ngOnInit() {
    this.initializeForm();
    this.getUserAndCarrier();
    this.hhgService.getRateTypesByBidCycle(this.rateBidCyclesId).pipe(takeWhile(() => this.observer$.value)).subscribe(response => {
      this.rateTypes = response as Array<RateTypes>;
      this.rateTypes.sort(function(a, b) {
        return a.legacyRateType - b.legacyRateType;
      });
    }, error => {
      this.alertService.error('Error while getting rate types');
    });

    this.carrierService.getCarrierObservable().pipe(takeWhile(() => this.observer$.value)).subscribe(carrier => {
      this.carrierEntity = carrier;
      this.isRsfp = this.carrierEntity.carrierType === 'RFSP';
      this.isRsfp ? this.rsfpCarrierId = this.carrierEntity.carrierId : this.rsfpCarrierId = 0;
      //console.log("rsfp carrier id:" + this.rsfpCarrierId);
    });

    if(this.isRsfp){
      this.carrierService.getAllRfspsCarriers(this.carrierEntity.carrierId).subscribe(
       result => { 
         this.rsfpCarrierList = result;
         this.rsfpCarrierList.sort((a,b) => a.scac > b.scac ? 1 : -1);
        //console.log(this.rsfpCarrierList);
       }, error => {
        this.alertService.error('Error while getting rfsp tsp list');
        }
      );
    }
    else{
      this.hhgTemplateForm.get('tspList').clearValidators();
    }
    this.message = '';
  }

  /**
   * @description initializes form group with controls
   */
  initializeForm() {
    this.hhgTemplateForm = this.fb.group({
      tspList: new UntypedFormControl('', Validators.required),
      rateType: new UntypedFormControl('', Validators.required),
      sroType: new UntypedFormControl('', Validators.required)
    });
  }
  /**
   * @description get the current user from observable and carrier ID based on user ID
   */
  getUserAndCarrier() {
    this.tmssloader.show();
    this.hhgService.getCarrierIdByUser().pipe(takeWhile(() => this.observer$.value)).subscribe(carrierId => {
      this.carrierId = carrierId;
      this.tmssloader.hide();
    }, error2 => {
      this.tmssloader.hide();
      this.alertService.error('Unable to load TSP info values. Please try again later or contact system administrator');
    });
  }

  /**
   * @description listens to value changes in rate type dropdown.
   */
  rateTypeChange() {
    this.message = '';
    this.hhgTemplateForm.get('sroType').patchValue(null);
    const rateType = this.hhgTemplateForm.get('rateType').value;
        this.hhgService.getSroByRateTypeAndBidCycle(rateType.rateTypeId, this.rateBidCyclesId).pipe(takeWhile(() => this.observer$.value)).subscribe(response => {
      this.sroTypeList = response as SROMaster[];
    }, error => {
      this.alertService.error('Error while getting Sro types');
    });
  }

  sroIdChange(){
    this.message = '';
  }

  tspChange(){
    this.message = '';
    this.hhgTemplateForm.get('rateType').patchValue(0);
    this.hhgTemplateForm.get('sroType').patchValue(null);
    const tsp = this.hhgTemplateForm.get('tspList').value;
    this.downloadCarrierId = tsp.carrierId;
    //console.log("downloadCarrierId = " + this.downloadCarrierId);
    //console.log("download scac = " + tsp.scac);
  }

  getHhgFile() {
    const formValue = this.hhgTemplateForm.value;
    if(this.isRsfp)
       this.carrierId = this.downloadCarrierId;
    
    //console.log(formValue);
    if (this.hhgTemplateForm.value) {
      this.tmssloader.show();
      let hhgrRatesResult: DownloadFileResponse;
      let hhgRatesResponse: String;
      this.hhgrateService.getHhgTemplateFile(formValue.rateType.legacyRateType, 
                                             formValue.sroType === 'null' ? null : formValue.sroType, 
                                             this.carrierId, this.rateBidCyclesId,this.rsfpCarrierId)
                                             .subscribe(res => {
                                              hhgRatesResponse = res as String;
                                              //this.alertService.success("Your download request has been received. System will create the file and notify you via email once the file is ready"); 
                                              this.message = "Your download request has been received. System will create the file and notify you via email once the file is ready";
                                              this.tmssloader.hide();
                                             },error=>{
                                              this.alertService.success("Your download");
                                              this.tmssloader.hide();
                                             }
                                             );
                                                                      
                                           /*  .pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
                                                                                              
        console.log(res);
        hhgrRatesResult = res as DownloadFileResponse;
        const byteData: number[] = hhgrRatesResult.byteData;
        const fileName: string = hhgrRatesResult.fileName;
        const numRows: number = hhgrRatesResult.numberOfExcelRows;
        const bytes = new Uint8Array(byteData);
        const blob = new Blob([bytes], {
          type: null
        });
        console.log(numRows);
        FileSaver.saveAs(blob, fileName);
        this.alertService.success(hhg_download_template_success);
        this.tmssloader.hide();
      }, error => {
        console.log("sy-rate downlaod fail");
        this.tmssloader.hide();
        this.alertService.error('Error while getting the template.');
      });*/
    } else {
      this.alertService.info('please make sure all options are selected, if issue persists please FRT Rate Filing menu');
    }
  }

  /**
   * @description emitting the observer subject to false to stop all the subscriptions.
   */
  ngOnDestroy() {
    this.observer$.next(false);
  }

}
